import Vue from "vue"
import Router from "vue-router"
import Home from "@/views/Home.vue"
import Menu from "@/views/Menu.vue"
import Search from "@/views/Search.vue"
import NotFound from "@/views/NotFound.vue"
import LateJobList from "@/views/job/LateJobList.vue"
import UntimedJobList from "@/views/job/UntimedJobList.vue"
import RemoteSignatureView from "@/views/job/RemoteSignatureView.vue"
import MicrosoftInfo from "@/views/info/MicrosoftInfo.vue"
import JobRouter from "@/views/job/JobRouter"
import WorkReportRouter from "@/views/workreport/WorkReportRouter"
import UXXRouter from "./views/uxx/uxxrouter"
import CustomFormRouter from "./views/customform/CustomFormRouter"
import MapRouter from "./views/map/MapRouter"
import SettingsRouter from "./views/settings/SettingsRouter"
import PlanningRouter from "./views/planning/PlanningRouter"
import HistoryRouter from "./views/history/HistoryRouter"
import DirectoryRouter from "./views/directory/DirectoryRouter"
import CustomerRouter from "./views/customer/CustomerRouter"
import AssetRouter from "./views/asset/AssetRouter"
import UserRouter from "./views/user/UserRouter"
import OrderRouter from "./views/order/OrderRouter"
import GroupRouter from "./views/group/GroupRouter"
import NotificationsRouter from "./views/notifications/NotificationsRouter"
import { useApolloClient } from '@vue/apollo-composable'
import * as cdn from "@coredination/components"

Vue.use(Router)

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "root",
            component: Home,
        },
        {
            path: "/home",
            name: "home",
            component: Home,
        },
        {
            path: "/search",
            name: "search",
            component: Search,
        },
        {
            path: "/menu",
            name: "menu",
            component: Menu,
        },
        {
            path: "/late",
            name: "late",
            component: LateJobList,
        },
        {
            path: "/untimed",
            name: "untimed",
            component: UntimedJobList,
        },
        {
            path: "/tokenlogin/:token",
            name: "tokenlogin",
            props: true,
            beforeEnter: async (to, from, next) => {
                const apolloClient = useApolloClient().client;
                try {
                    await cdn.apollo.onLogin(apolloClient, to?.params?.token);
                } catch (error) {
                    console.error('Authentication failed:', error);
                }
                next('/');
            },
        },
        {
            path: "/smartcrafteula/:smartcraft_token",
            name: "smartcrafteula",
            props: true,
            beforeEnter: async (to, from, next) => {
                if (to && to.params && to.params.smartcraft_token) sessionStorage.setItem('smartcraft_token', to.params.smartcraft_token)
                next('/');
            },
        },
        {
            path: "/remotesignature/:id",
            name: "remotesignature",
            props: true,
            component: RemoteSignatureView,
        },
        {
            path: "/index.html",
            name: "index",
            component: Home,
        },
        {
            path: "/about",
            name: "about",
            meta: {
                noAuthRequired: true,
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ "./views/About.vue"),
        },
        {
            path: "/microsoftInfo",
            name: "microsoftInfo",
            meta: {
                noAuthRequired: true,
            },
            component: MicrosoftInfo,
        },
        ...JobRouter,
        ...WorkReportRouter,
        ...UXXRouter,
        ...CustomFormRouter,
        ...MapRouter,
        ...SettingsRouter,
        ...PlanningRouter,
        ...HistoryRouter,
        ...DirectoryRouter,
        ...CustomerRouter,
        ...AssetRouter,
        ...UserRouter,
        ...OrderRouter,
        ...GroupRouter,
        ...NotificationsRouter,
        {
            path: "/:catchAll(.*)",
            name: "notfound",
            component: NotFound,
            meta: {
                noAuthRequired: true,
            },
        },
    ],
})
